import { createContext, useContext } from "react";
import type { ReactNode } from "react";
import { UI_COPY } from "@backcoach/content";
import { useResource, unwrap } from "./client.js";

/**
 * Interface copy: served by the API, bundled as the fallback (D-33). A screen
 * asks for a key and gets the served line if there is one, else the bundled
 * line, else the key itself so a missing entry is visible rather than blank.
 */
const CopyContext = createContext<Readonly<Record<string, string>>>(UI_COPY);

export function CopyProvider({ children }: { children: ReactNode }) {
  const served = useResource(async (api) => unwrap(await api.GET("/v1/copy")));
  const entries = served.data ? { ...UI_COPY, ...served.data.entries } : UI_COPY;
  return <CopyContext.Provider value={entries}>{children}</CopyContext.Provider>;
}

export function useCopy(): (key: string) => string {
  const entries = useContext(CopyContext);
  return (key) => entries[key] ?? key;
}

export { copyFrom } from "./copy-data.js";
